"use client";
import React from "react";
import Icon from "components/common/Icon";
import Avatar from "components/common/Avatar";
import { useRouteContext } from 'utils/providerMigration';
import { useChatStore } from 'stores';

interface ChatHeaderProps {
  userName?: string;
  userAvatar?: string;
  isOnline?: boolean;
  lastSeen?: string;
  onMoreClick?: () => void;
}

export default function ChatHeader(props: ChatHeaderProps) {
  const { router } = useRouteContext();
  const { currentChatRoom } = useChatStore();

  // Use props if provided, otherwise use data from store
  const userName = props.userName || currentChatRoom?.customer?.name || "Khách hàng";
  const userAvatar = props.userAvatar || "";
  const isOnline = props.isOnline || false;
  const lastSeen = props.lastSeen || "Hoạt động 5 phút trước";
  const onMoreClick = props.onMoreClick;

  return (
    <div className="w-full bg-primary rounded-b-2xl">
      <div className="flex items-center justify-between px-4 py-3 h-[60px]">
        <button
          onClick={() => router.back()}
          className="p-2 -ml-2 rounded-full transition-colors hover:bg-white hover:bg-opacity-20"
          aria-label="Go back"
        >
          <Icon name="arrow-right" size={20} color="#fff" className="rotate-180" />
        </button>

        <div className="flex items-center gap-3 flex-1 ml-2">
          <Avatar
            src={userAvatar}
            name={userName}
            size="small"
            gradientSeed={userName}
          />
          <div className="flex flex-col">
            <h1 className="text-base font-semibold text-white leading-tight">{userName}</h1>
            <span className="text-xs text-white text-opacity-90 flex items-center gap-1">
              {isOnline ? (
                <>
                  <span className="w-2 h-2 bg-white rounded-full inline-block"></span>
                  Đang hoạt động
                </>
              ) : (
                lastSeen || "Hoạt động 5 phút trước"
              )}
            </span>
          </div>
        </div>

        <button
          className="p-2 -mr-2 rounded-full transition-colors hover:bg-white hover:bg-opacity-20"
          aria-label="More options"
          onClick={onMoreClick}
        >
          <Icon name="more-vertical" size={20} color="#fff" />
        </button>
      </div>
    </div>
  );
}